module.exports = [
  {
    title: 'Ремонт дизельных двигателей',
    info:
      'Дизельные двигатели в большинстве случаев весьма надежны и долговечны. Особенно если проходить ТО своевременно. Важно использовать качественное топливо, вовремя менять расходники.  Современные дизеля становятся все сложнее обрастая электроникой, различными навесными системами для обеспечения безотказной работы в разных условиях работы.',
    items: [
      {
        title: 'Капитальный ремонт ДВС',
        info:
          'Капитальный ремонт дизельного двигателя одна из самых трудоемких операций по ремонту дизельных авто. Если по результатам диагностики выявлена неисправность в ДВС, двигатель нужно будет:',
        list: [
          'демонтировать дизельный двигатель',
          'отмыть детали',
          'произвести дефектовку, осмотр коленвала, параметры зазоров,трещины',
          'ремонт головки блока цилиндров, блока цилиндров, ремонт коленвала'
        ]
      },
      {
        title: 'Замена навесных узлов и агрегатов',
        info:
          'Дизельные двигатели могут быть оборудованы дополнительными устройствами. Наш сервис предоставляют услуги по замене и ремонту некоторых из них. Просим обратить внимание, что некоторые такие устройства не поддаются ремонту. К услугам по ремонту навесным узлам и агрегатам дизельного двигателя относятся:',
        list: [
          'Ремонт, замена турбины(турбонаддув)',
          'впускной/выпускной коллекторы',
          'клапан EGR',
          'помпа'
        ]
      }
    ]
  },
  {
    title: 'Компьютерная диагностика',
    info:
      'Современные автомобили обладают большим количеством электроники, которая следит за каждым узлом автомобиля. Вся эта информация обрабатывается блоком управления. Какие то основные ошибки в работе авто можно увидеть на приборной панели. При поступлении автомобиля на наш сервис одним из обязательных условий ремонта является компьютерная диагностика. Она позволяет более точно судить о неисправности того или иного узла автомобиля.',
    items: [
      {
        title: 'Компьютерная диагностика Bosch',
        info:
          'Во многих автомобилях установлена топливная техника Bosch. Это один из лидеров по производству топливной аппаратуры для дизельных двигателей. Наш сервис предоставляет компьютерную диагностику такой техники с помощью Bosch KTS. Это позволяет детально изучить такие параметры:',
        list: [
          'считывание/стирание кодов неисправностей',
          'вывод текущих параметры системы в цифровом/графическом виде',
          'активирует специальные режимы работы контроллера',
          'описывает расположение диагностических колодок',
          'сбрасывает сервисные счетчики',
          'контролирует уровень масла',
          'разблокирует иммобилайзер',
          'проверка ESP',
          'другие функции (чтение VIN, статический тест и т.д.)'
        ]
      },
      {
        title: 'Компьютерная диагностика Delphi',
        info:
          'Также одним из лидеров топливной дизельной аппаратуры является Delphi. Для этого оборудования в нашем сервисе имеется официальная диагностика Delphi. Кроме всего прочего диагностический прибор Delphi позволяет проводить диагностику:',
        list: [
          'двигателя по заводским протоколам',
          'систем управления климатом',
          'иммобилайзеров',
          'систем управления трансмиссией',
          'систем ABS',
          'систем SRS Airbag',
          'систем обеспечения комфорта',
          'систем кузовной электроникиа'
        ]
      },
      {
        title: 'Компьютерная диагностика OEM',
        info:
          'Кроме таких мульти-сканеров которые предлагает Bosch и Delphi, в нашем распоряжении есть оригинальная диагностика от производителей авто. Она позволяет провести полную диагностику авто конкретной марки. В отдельных случаях позволяет считать те параметры, которые не могут считать мульти-марочные сканеры.',
        list: [
          'компьютерная диагностика Mercedes-Benz',
          'компьютерная диагностика VW',
          'компьютерная диагностика Volvo',
          'компьютерная диагностика Scania',
          'OEM компьютерная диагностика двигателей Cummins, Detroit Diesel, Caterpillar'
        ]
      },
      {
        title: 'Выездная диагностика',
        info:
          'Возможна выездная диагностика. Должны заметить, что диагностика это лишь часть ремонта, в которой определяется причина неисправности. В некоторых отдельных случаях не представляется возможным провести диагностику на месте. Иногда нужно провести частичную разборку, загнать машину на яму, провести диагностику дополнительным оборудованием (осцилографом, нанометром). В большинстве случаев мы советуем Вам транспортировать технику в наш сервис и на месте решать проблему.'
      }
    ]
  },
  {
    title: 'Ремонт электрики',
    info:
      'Электрика в автомобиле это одна из важнейших частей которая требует ухода и качественного ремонта. Некачественные соединения проводки могут вызвать неисправность остальных узлов. Короткое замыкание может привести к непредвиденным результатам, от выхода из строя датчиков и блока управления до пожара. Мы вас предостерегаем, без должного уровня не стоит самому заниматься ремонтом электрической части автомобилей.',
    items: [
      {
        title: 'Ремонт генератора/стартера',
        info: 'Ремонт генератора происходит в несколько этапов:',
        list: [
          'демонтаж генератора/стартера',
          'дефектовка генератора/стартера',
          'непосредственно ремонт генератора/стартера',
          'замена подшипников, замена щеток',
          'монтаж генератора/стартера'
        ]
      },
      {
        title: 'Общие работы по электрике',
        info: 'В общие работы по электрике входит:',
        list: [
          'ремонт/замена систем охлаждения, радиаторов',
          'ремонт печи',
          'ремонт проводки',
          'ремонт блока предохранителей',
          'ремонт/замена блока реле'
        ]
      }
    ]
  },
  {
    title: 'Ремонт электроники',
    info:
      'Современный автомобиль сложно себе представить без электроники. Эти устройства выполняют различную логику. Например следят уровнем масла, количеством топлива которое получает двигатель и т.д. Вся эта информация поступает в центральный блок управления, который хранит, анализирует, управляет большинством узлов автомобиля.',
    items: [
      {
        title: 'Удаление сажевого фильтра',
        info:
          'Мы предлагаем отключение / деактивацию/ удаление сажевого фильтра (DPF/FAP). Одной из причин удаления сажевого фильтра может стать:',
        list: [
          'потеря мощности в нормальном режиме работы двигателя',
          'увеличение расхода топлива',
          'горит ошибка чек'
        ]
      },
      {
        title: 'Удаление EGR',
        info:
          'Система EGR (Система рециркуляции отработавших газов) предназначена для снижения образования оксидов азота, образуемых при работе двигателя. В некоторых случаях использование этой системы начинает негативно влиять на работу двигателя. Наш сервис предоставляет услугу по удалению клапана EGR. Мы предлагаем чистку, отключение EGR в Донецке:',
        list: [
          'програмное отключение клапана EGR',
          'установка заглушки клапана EGR'
        ]
      },
      {
        title: 'Ремонт/замена блока управления',
        info:
          'Блоки управления (ECU) довольно надежны и ломаются редко. Причинами выхода из строя могут является: влага проникшая внутрь корпуса ECU, механические воздействия, неполадки в электропитании.',
        list: [
          'програмное отключение клапана EGR',
          'установка заглушки клапана EGR'
        ]
      }
    ]
  },
  {
    title: 'Ремонт дизельной топливной аппаратуры',
    info:
      'Мы обслуживаем в Донецке ТНВД, насос-форсунки, форсунки, системы Common Rail уже 17 лет. В нашем распоряжении оборудование от официальных производителей систем Bosch, Hartridge, Delphi, Denso. Это позволяет делать высокоточные проверки и настройки.',
    items: [
      {
        title: 'Ремонт ТНВД и форсунок',
        info:
          'Ремонт ТНВД и форсунок начинается с диагностики на стенде, осмотра под микроскопом степени износа. На стенде проверяются форсунки для оценки объема распыляемого топлива, проводится замер фактических параметров. Проводится сравнение с эталонными параметрами.В Донецке диагностируем , делаем регулировку и ремонт ТНВД и форсунок:',
        list: [
          'одноплунжерных насосов типа VE с механическими и электронными регуляторами производства BOSCH, ZEXEL, DENSO',
          'ТНВД производства DELPHI (LUCAS) часто применяемых на легковых автомобилях, строительной и специализированной технике',
          'рядных ТНВД  А, М, MW, P-типа с механическими и электронными регуляторами, Н-типа, производства BOSCH, ZEXEL, DENSO',
          'ТНВД отечественной техники КамАЗ, ЯМЗ-236,ЯМЗ-238, ЯМЗ-240, МТЗ, СуперМАЗ ЕВРО-2, IKARUS',
          'форсунок BOSCH,ZEXEL,DENSO однопружинных, двухступенчатых, форкамерных, непосредственного впрыска, а также форсунок отечественного производства'
        ]
      },
      {
        title: 'Ремонт насос-форсунок',
        info:
          'Насос-форсунка объединяет в себе и одноплунжерный насос и форсунку. За счет того, что за смазку трущихся деталей отвечает топливо, это становится одной из главных проблем выхода из строя насос-форсунки. Выполняем проверку, ремонт, замену насос-форсунок:',
        list: [
          'насос-форсунок легковых автомобилей VW, Skoda',
          'насос-форсунок,PLD секций (насосных секций высокого давления) автомобилей МВ, VOLVO, SCANIA, DAF, IVECO',
          'насос-форсунок, американского производства DETROIT DIESEL, CAT, Cummins'
        ]
      },
      {
        title: 'Ремонт системы Common Rail',
        info:
          'Можно считать что Common Rail это вершина эволюции топливной аппаратуры дизельных двигателей. В отличии от ТНВД конструкция упрощена,  топливо закачивается в одному рейку . С другой стороны за систему подачи топлива отвечают электронно управляемые форсунки. Так сама рейка оснащена большим количеством датчиков отвечающих за давление в рейке, систем аварийного сброса давления. Ремонт таких систем требует спец оборудования, а также должной квалификации.В Донецке выполняем диагностику,ремонт систем Common Rail, форсунок:',
        list: [
          'Delphi на оборудовании фирмы HARTRIDGE дополнительно оснащенном дилерским программным обеспечением DELPHI которое позволяет при успешном прохождении теста присваивать форсунке индивидуальный код, который при монтаже прописывается в блок управления двигателя с привязкой к номеру цилиндра на который устанавливается форсунка.',
          'BOSCH широко применяющихся как на легковых так и на грузовых автомобилях и спецтехнике Европейского, Азиатского,  Японского производства.  Ремонт производится с соблюдение технологии ремонта и регулировочных параметров фирмы BOSCH',
          'DENSO устанавливаемых на автомобилях TOYOTA, NISSAN, FORD, CITROEN, PEUGEOT, MAZDA,SUBARU, OPEL, ISUZU, а также сельскохозяйственной и специализированной технике JOHN DEERE, JCB, HITACHI, KOMATSU'
        ]
      }
    ]
  },
  {
    title: 'ТО дизельной техники',
    info:
      'Наш сервис предлагает обслуживание вашего авто на регулярной основе. Меняйте фильтра, масло своевременно. Ведь это продлит срок службы вашего авто. После прохождения ТО делаем обнуление сервиса.',
    items: [
      {
        title: 'Замена фильтров',
        info:
          'Заблаговременно меняя фильтры вы оберегаете себя от дорогостоящего ремонта. Причины сменить топливный фильтр:',
        list: [
          'увеличился расход топлива',
          'уменьшилась мощность двигателя',
          'двигатель начинает троить',
          'двигатель глохнет на холостом ходу',
          'при повышении оборотов в работе двигателя происходят провалы'
        ]
      },
      {
        title: 'Замена масла',
        info:
          'Наличие масла на всех узлах гарантирует отсутствие трения и преждевременного износа деталей вашего автомобиля. Не упустите того момента когда масло закончится, ведь масло:',
        list: [
          'защищает двигатель от износа',
          'защищает детали от перегрева',
          'защищает поверхность металла от коррозии',
          'выводит твердые продукты сгорания топливно-воздушной смеси (нагар, сажа и др.)',
          'выводит продукты износа двигателя (металлическая стружка)'
        ]
      },
      {
        title: 'Замена свечей накала',
        info:
          'Меняем вышедшие из строя свечи накаливания. Симптомы нестабильной работы свечей накала на дизельном автомобиле:',
        list: [
          'затрудненный запуск двигателя',
          'наличие белого дыма из выхлопной трубы'
        ]
      }
    ]
  },
  {
    title: 'Ремонт дизельной грузовой и спецтехники',
    info:
      'Современные грузовые траки и спецтехника почти на 90 процентов приводится в движение с помощью дизельных двигателей. Автосервис Автодизель выполнит диагностику, ремонт грузовых траков, погрузчиков, тракторов, сельхоз техники.',
    items: [
      {
        title: 'Ремонт грузовой дизельной техники',
        info: 'Отремонтируем грузовые автомобили:',
        list: [
          ' RENAULT (РЕНО), VOLVO (ВОЛЬВО)-(Америка), MERCEDES-BENZ TRUCK (Мерседес-Бенц трак), SCANIA (СКАНИЯ), DAF (ДАФ), MAN (МАН), IVECO (ИВЕКО), Hino (ХИНО), ShacMan (Шакман), HYUNDAI (Хундай), MACK (МАК), MITSUBISHI (МИТСУБИСИ), NISSAN (НИССАН), ISUZU (ИСУЗУ), VOLVO (ВОЛЬВО), FREIGHTLINER (Фредлайнер), CATERPILLAR (Катерпиллер), FORD (ФОРД), INTERNATIONAL (Интернационал), JCB (ДжиСиБи), FOTON (Фотон), FAW (ФАВ), HOWO (ХОВО), Dongfeng (Донг Фенг), Shaanxi (Шанк Си), BAW (БАВ), КАМАЗ, ГАЗ, ЗИЛ'
        ]
      },
      {
        title: 'Сельхоз и спецтехника',
        info: 'Ремонт дизельной сельхоз и спецтехники в Донецке',
        list: [
          'экскаваторов и погрузчиков VOLVO EW, EC, JCB, CASE, NEW HOLLAND, LIEBHERR, ATLAS, TEREX, KOMATSU, HITACHI',
          'тракторов MEDION 310, FORD CARGO 3530, HUNTER, FENDT 936, CASE 310, MASSEY FERGUSON 8480, NEW HOLLAND T8050, JOHN DEERE 7820, 8336, 8420, 8850,9320, 9430, ROPA'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/services.js